import type { RouteResource } from 'react-resource-router';

import type { PaginationRouteResource } from '@atlassian/eoc-pagination';

import type { IncomingCallDetail } from '../../common/types';

import { detailResource } from './detail';
import { listResource } from './list';

const listResources = (): PaginationRouteResource<{
	callResponders: {
		id: string;
		type: 'user' | 'team' | 'escalation' | 'schedule';
	}[];
	enabled: boolean;
	id: string;
	isAtlassianManagedNumber: boolean;
	name: string;
	phoneNumber: string;
}>[] => [listResource];

const detailResources = (): RouteResource<IncomingCallDetail>[] => [detailResource];

export { listResources, detailResources };
